import script from "./AltLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./AltLanding.vue?vue&type=script&setup=true&lang=js"

import "./AltLanding.vue?vue&type=style&index=0&id=2c118ba1&lang=css"

const __exports__ = script;

export default __exports__